export enum DocumentStatus {
  Signable = "SIGNABLE",
  Signed = "SIGNED",
  PartSigned = "PARTSIGNED",
  NeedsAttention = "NEEDS ATTENTION",
  Voided = "VOIDED"
}
